import { useState, useEffect, useCallback } from 'react';
import Joyride, { STATUS } from 'react-joyride';


const STEPS = [
  {
    target: '#tour-profile-menu',
    title: 'Your profile menu',
    content: 'Click here to access your account options — including SOAP note history, subscription settings, and sign out.',
    placement: 'bottom-end',
    disableBeacon: true,
  },
  {
    target: '#patientSearch',
    title: 'Search for a patient',
    content: "Type a patient's name, email, date of birth, or phone number to find and select them before starting a visit.",
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#tour-add-patient',
    title: 'Add a new patient',
    content: "First visit? Click here to register a new patient with their name, email, and date of birth.",
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#appointmentDate',
    title: 'Set the appointment date',
    content: "Select today's date or a past appointment date. This is required before generating a SOAP note.",
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#tour-record',
    title: 'Record the appointment',
    content: 'Hit this button when the appointment starts to capture live audio. Click again to stop when finished.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#tour-attach-audio',
    title: 'Or attach a recording',
    content: 'Already have a recording? Upload an audio file here (MP3, M4A, WAV, and more). You can also drag and drop.',
    placement: 'top',
    disableBeacon: true,
  },
];

const joyrideStyles = {
  options: {
    primaryColor: '#2563eb',
    zIndex: 10000,
    arrowColor: '#ffffff',
    backgroundColor: '#ffffff',
    overlayColor: 'rgba(0, 0, 0, 0.45)',
    textColor: '#1e293b',
  },
  tooltip: {
    borderRadius: '12px',
    padding: '20px 24px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    maxWidth: '340px',
  },
  tooltipTitle: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '8px',
    color: '#0f172a',
  },
  tooltipContent: {
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#475569',
    padding: '0',
  },
  buttonNext: {
    backgroundColor: '#2563eb',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    padding: '8px 18px',
  },
  buttonBack: {
    color: '#64748b',
    fontSize: '14px',
    marginRight: '8px',
  },
  buttonSkip: {
    color: '#94a3b8',
    fontSize: '13px',
  },
};

export function DoctorOnboarding({ isFirstLogin }) {
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (isFirstLogin) {
      const timer = setTimeout(() => setRun(true), 800);
      return () => clearTimeout(timer);
    }
  }, [isFirstLogin]);

  const handleJoyrideCallback = useCallback((data) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setRun(false);
    }
  }, []);

  return (
    <Joyride
      steps={STEPS}
      run={run}
      continuous
      showSkipButton
      showProgress
      scrollToFirstStep
      styles={joyrideStyles}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Done',
        next: 'Next',
        skip: 'Skip tour',
      }}
      callback={handleJoyrideCallback}
    />
  );
}
